import getBG from '../../utils/utils';

export default {
    name: 'training-video',
    data() {
        return {
            backgroundImage: '',
            content: ''
        };
    },
    created() {
        this.init();
    },
    methods: {
        async init() {
            this.backgroundImage = await getBG.call(this, 'TrainingVideo');
            this.$http
                .fetchData('contentManage/getContentManageList', {
                    contentType: 'homePageTrainingVideo'
                })
                .then(res => {
                    this.content = res[0].content;
                })
                .catch(err => {
                    this.$message({
                        message: err,
                        type: 'error'
                    });
                });
        }
    }
};
